module.exports = ""


//////////////////
// WEBPACK FOOTER
// E:/Project/posSystem/src/app/pos/home/home.component.html
// module id = ../../../../../src/app/pos/home/home.component.html
// module chunks = main